const NUMERO_COMPROBANTE_MOCK = {
  nuevoNumeroComprobante: "FAB-0020-00158819",
};

const getNumeroComprobante = async idTalonario => {
  return {
    data: NUMERO_COMPROBANTE_MOCK,
  };
};

const numeroComprobante = {
  getNumeroComprobante,
};

export default numeroComprobante;
